import classNames from "classnames";
import {Breadcrumbs as MuiBreadcrumbs} from "@mui/material";
import {Props} from "./types";
import {Link} from "@/shared/ui/Link";
import {usePage} from '@inertiajs/react';
import styles from "./Breadcrumbs.module.scss";

export const Breadcrumbs = (
    {
        items,
        maxItems = 2,
        itemsAfterCollapse = 2,
        classes,
        // hideBreadcrumbs = false,
    }: Props
) => {
    // Временно, что бы не писать везде hideBreadcrumbs={hideBreadcrumbs}
    const {hideBreadcrumbs} = usePage().props;

    if (hideBreadcrumbs) return null;

    return (
        <MuiBreadcrumbs
            maxItems={maxItems}
            itemsAfterCollapse={itemsAfterCollapse}
            className={classNames(styles.root, classes?.root)}
        >
            {items.map((item, index) => {
                if (!item.href) {
                    return (
                        <p key={item.label} className={classNames(styles.text, classes?.text)}>
                            {item.label}
                        </p>
                    );
                }

                return (
                    <Link
                        key={item.href}
                        className={classNames(styles.link, classes?.link)}
                        href={item.href}
                    >
                        {item.label}
                    </Link>
                );
            })}
        </MuiBreadcrumbs>
    );
};
